import classNames from "classnames";
import React, { useMemo } from "react";
import { Form, InputGroup } from "react-bootstrap";
import PhoneInput from "react-phone-number-input/input";

import { useAppSelector } from "../../redux/Store";
import { ITRFilingSelector } from "../../redux/slice/ITRFilingSlice";

type Props = {
  name: string;
  value: string;
  onChange: (value?: any) => void;
  onBlur: any;
  label?: string;
  isInvalid?: boolean;
  errorMsg?: string;
  isDisabled?: boolean;
  formType?: "ITR" | "GENERAL";
};

const PhoneInputField: React.FC<Props> = (props: Props) => {
  const {
    name,
    value,
    onChange,
    onBlur,
    label,
    isInvalid,
    errorMsg,
    isDisabled = false,
    formType = "ITR"
  } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const isFieldDisabled = useMemo(() => {
    if (formType === "GENERAL") {
      if (isDisabled) {
        return isDisabled;
      }
      return false;
    }
    if (isFilingReadOnly) {
      return true;
    }
    return isDisabled;
  }, [isDisabled, isFilingReadOnly, formType]);

  return (
    <Form.Group className="form-group" controlId={name}>
      {label ? <Form.Label className="small-label">{label}</Form.Label> : null}
      <InputGroup className={classNames(isFieldDisabled && "is-disabled")}>
        <InputGroup.Text className={classNames("prepend-text", isInvalid && "border-danger")}>
          +91
        </InputGroup.Text>
        <PhoneInput
          country="IN"
          placeholder="XXXXX XXXXX"
          international={false}
          withCountryCallingCode={false}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={classNames("form-control", isInvalid && "border-danger")}
          readOnly={isFieldDisabled}
        />
      </InputGroup>
      {isInvalid && errorMsg ? <div className="field-error">{errorMsg}</div> : null}
    </Form.Group>
  );
};

export default PhoneInputField;
